import { useDispatch, useSelector } from "react-redux";
import { updateLanguage } from "../store/slice/config";
import { useTranslation } from "react-i18next";

const useLanguage = () => {
  const { i18n } = useTranslation();

  const dispatch = useDispatch();
  const { language } = useSelector((state) => state.config);

  const setCurrency = (value) => {
    i18n.changeLanguage(value);
    dispatch(updateLanguage(value));
    window.location.reload();
  };

  return [language, setCurrency];
};

export default useLanguage;
